module.exports = "<app-header></app-header>\n <div class=\"container-fluid py-5 allcenter\">\n     <div class=\"row w-100\">\n         <div class=\"col-md-12 text-center\">\n            <h1 class=\"text-uppercase\">404</h1>\n            <h3 class=\"text-grey mt-2\">PAGE NOT FOUND</h3>\n            <a uiSref=\"dashboard\" class=\"btn btn-blue\">DASHBOARD</a>\n         </div>\n     </div>\n</div>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/not-found/not-found.component.html
// module id = ../../../../../src/app/components/not-found/not-found.component.html
// module chunks = main